// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__vcGDy","control":"Checkout_control__eRGbE","actions":"Checkout_actions__hnVZ9","submit":"Checkout_submit__qR6tN","invalid":"Checkout_invalid__Amsjt"};